import React, { FC, ReactNode } from "react";

import { Stack } from "react-bootstrap";

import { useAuthenticator } from "@aws-amplify/ui-react";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { ROUTES } from "src/routes";

import logo from "@assets/rrs-logo-single-colour.svg";

import styles from "./RegisterPageOutline.module.scss";

const Navigator: React.FC<{ showLogIn: boolean }> = ({ showLogIn }) => {
  const { toSignIn, toSignUp } = useAuthenticator((context) => [context.user]);
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate(ROUTES.ExternalSignIn.path);
    toSignIn();
  };

  const handleRegisterClick = () => {
    navigate(ROUTES.ExternalRegister.path);
    toSignUp();
  };

  return (
    <div className={styles["sign-in-navigator"]}>
      <span className={classNames(styles["login-link-support-text"], "b4 medium")}>
        {showLogIn ? "Already have an account? " : "Don't have an account yet? "}
      </span>
      <span
        className={classNames(styles["login-link"], "b4 medium")}
        onClick={showLogIn ? handleLoginClick : handleRegisterClick}
      >
        {showLogIn ? "Log in" : "Register"}
      </span>
    </div>
  );
};

const Disclaimer = () => {
  return (
    <Stack direction="vertical" gap={2} className={styles["disclaimer-container"]}>
      <div className="b3 bold">Acknowledgement of Country</div>
      <span className="b3">
        We acknowledge the Traditional Custodians on whose land our office stands: the Gadigal of the Eora nation. We
        value their heritage, beliefs and relationship with the land, which are often expressed through art. We pay our
        respects to their Elders past and present.
      </span>
    </Stack>
  );
};

export const RegisterPageOutline: FC<{ children: ReactNode; showLogIn: boolean; displayNavigator?: boolean }> = ({
  children,
  showLogIn,
  displayNavigator = true,
}) => {
  return (
    <>
      <Stack className={styles["background-image"]}>
        <Link className="z-3" to={ROUTES.Dashboard.path}>
          <ReactSVG src={logo} className={styles["svg-container"]} />
        </Link>
      </Stack>
      <Stack className={styles["contents"]} direction="vertical">
        {displayNavigator && <Navigator showLogIn={showLogIn} />}
        <div className={styles["authenticator-wrapper"]}>{children}</div>
        <Disclaimer />
      </Stack>
    </>
  );
};
